export const getSite = typeof window !== 'undefined' && window.location.hostname ? window.location.hostname : '';
